import { Prompt } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import Errors from "./../../../shared/errors";
import {
  renderSingleReactSelect
} from "./../../../shared/form-helpers";
import required from "./../../../shared/validation";

function CharacterForm(props) {
  const {
    handleSubmit,
    handleDelete,
    pristine,
    reset,
    submitting,
    errors,
    mode,
    visualEffects,
    noVisualEffectsForFilm
  } = props;

  const thisVisualEffect = props.initialValues || {};
  const readOnly = thisVisualEffect.readOnly;

  const visualEffectOptions = visualEffects?.map((e) => {
    return { label: e.name, value: e.id };
  });

  const noVisualEffects = !visualEffectOptions?.length;

  return (
    <>
      <Prompt when={!pristine} message="" />
      {mode === "add" && <h2 className="menu-label">Add visual effect to scene</h2>}
      {mode === "edit" && (
        <h2 className="menu-label">Edit visual effect in scene</h2>
      )}
      {errors && <Errors errors={errors} />}
      {noVisualEffects &&
        <>
          {noVisualEffectsForFilm && <div>No visual effects added to film</div>}
          {!noVisualEffectsForFilm && <div>All visual effects already added to scene</div>}
        </>}

      {!noVisualEffects &&
        <form autoComplete="off" onSubmit={handleSubmit}>
          {mode === "add" && (
            <Field
              name="visualEffectId"
              label="Visual Effect"
              component={renderSingleReactSelect}
              value={thisVisualEffect.visualEffectId}
              validate={[required]}
              options={visualEffectOptions}
              required
              readOnly={readOnly}>
            </Field>
          )}
          {mode === "edit" && (
            <div className="field">
              <label className="label">
                Visual Effects
              </label>
              <div className="control">
                {thisVisualEffect.name}
              </div>
            </div>
          )}

          {!readOnly && <div className="buttons">
            <button
              type="submit"
              className="button is-primary"
              disabled={pristine || submitting}>
              Save
            </button>

            {mode === "edit" && (
              <button
                type="button"
                className="button is-text"
                disabled={submitting || !props.initialValues}
                onClick={() => handleDelete(thisVisualEffect)}>
                Remove from scene
              </button>
            )}
          </div>}
        </form>}
    </>
  );
}

export default reduxForm({
  form: "CharacterForm",
  enableReinitialize: true
})(CharacterForm);
